import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <Result
      style={{ alignContent: "center", verticalAlign: "middle" }}
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Button type="primary" onClick={() => navigate("/dashboard")}>
          Back Home
        </Button>
      }
    />
  );
};

export default NoAccess;
